import { render } from "./App.vue?vue&type=template&id=035defd4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=035defd4&lang=scss"
script.render = render

export default script